import React, { FunctionComponent, ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import { SharedDashboardContainer } from './components/SharedDashboardContainer';
import { Error } from './routes/error';
import './App.css';

const App: FunctionComponent<{ env }> = (props): ReactElement => (
	<Routes>
		{/* Dashboards */}
		<Route
			element={
				<SharedDashboardContainer
					baseUrl={props.env.sharedDashboardServiceUrl}
				/>
			}
			path='/dashboard/:sharedDashboardUuid'
		/>
		{/* 404 */}
		<Route element={<Error />} path='*' />
	</Routes>
);

export { App };
